import React from 'react';
import { Button } from 'react-bootstrap';
import { Stepper, Step } from 'react-form-stepper';
import "../scss/multiStep.scss"; // You can keep this for other styles, but the progress bar part is handled by the package
import BackButton from './BackButton';

const MultiStep = ({ steps, currentStep, onNext, onBack, children, disableNextButton }) => {
  // The 'Stepper' component handles the entire progress bar visualization.
  // The 'activeStep' prop (0-indexed) tells it which step is currently active.
  // We subtract 1 from 'currentStep' to align with the package's 0-indexed system.
  return (
    <div className="multi-step-container">
        <div className="stepper-wrapper">
          <Stepper
            activeStep={currentStep - 1}
            styleConfig={{
              activeBgColor: '#007bff',
              completedBgColor: '#007bff',
              inactiveBgColor: '#ccc',
              activeTextColor: 'white',
              completedTextColor: 'white',
              inactiveTextColor: 'white'
            }}
            connectorStyleConfig={{
              activeColor: '#007bff',
              completedColor: '#007bff',
              inactiveColor: '#ccc'
            }}
            connectorStateColors
          >
            {steps.map((label, index) => (
              <Step key={index} label={label} />
            ))}
          </Stepper>
        </div>

        <div className="step-content">{children}</div>
      <div className="step-navigation d-flex justify-content-between">
          <BackButton handleBack={onBack}/>
        <Button variant="success" onClick={onNext} disabled={disableNextButton}>
          {currentStep === steps.length ? "Submit" : "Continue"}
        </Button>
      </div>
    </div>
  );
};

export default MultiStep;